var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        attrs: {
          title: "메일 발송 대상 목록",
          columns: _vm.columns,
          data: _vm.rows,
          gridHeight: "450px",
          autoFullHeight: false,
          columnSetting: false,
          filtering: true,
          usePaging: false,
          isExcelDown: false,
          isFullScreen: false,
          editable: false,
          selection: "none",
          rowKey: "mdmMaterialRegulatoryInfoHistoryMailId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }